import { FC, PropsWithChildren } from 'react';
import CheckboxProps from './CheckboxProps';

const Checkbox: FC<PropsWithChildren<CheckboxProps>> = ({
  id,
  helperText,
  error,
  label,
  ...rest
}) => {
  return (
    <div className="flex items-center">
      <input
        checked
        id={id}
        type="checkbox"
        className="h-4 w-4 rounded border-gray-300 bg-gray-100 text-primary-main focus:ring-2 focus:ring-primary-light dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-primary-main"
        {...rest}
      />
      {label && (
        <label
          htmlFor={id}
          className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
        >
          {label}
        </label>
      )}

      {helperText && (
        <span
          className={`text-xs ${error ? 'text-red-500' : 'text-jblood-black'}`}
        >
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
